import AboutScreen from "@/app/(app)/(crew)/about";

export default AboutScreen;
